export default __webpack_public_path__ + "4e9439c92a7cdaf4e14f81058a8e2f5a.pdf";